import React from "react";
import Container from "./Container.js";
import {CircularProgress} from "@material-ui/core";

export default ({containerStyles, disableCentring, size}) => (
	<Container centre={!disableCentring} style={containerStyles}>
		<CircularProgress disableShrink={true} size={size} />
	</Container>
);
